import React, { useEffect, useState } from 'react';
import { Button } from './ui/button';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';

const useTargetRect = (tourId) => {
  const [rect, setRect] = useState(null);
  useEffect(() => {
    if (!tourId) { setRect(null); return undefined; }
    const el = document.querySelector(`[data-tour="${tourId}"]`);
    if (!el) { setRect(null); return undefined; }
    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    const update = () => setRect(el.getBoundingClientRect());
    update();
    const interval = setInterval(update, 250);
    window.addEventListener('scroll', update, true);
    window.addEventListener('resize', update);
    return () => {
      clearInterval(interval);
      window.removeEventListener('scroll', update, true);
      window.removeEventListener('resize', update);
    };
  }, [tourId]);
  return rect;
};

export const MobileTourCard = ({ steps, currentStep, onNext, onPrev, onSkip }) => {
  const step = steps[currentStep];
  const rect = useTargetRect(step.tour);
  const Icon = step.icon;
  const isLast = currentStep === steps.length - 1;

  return (
    <>
      {rect && (
        <div
          className="fixed z-[9997] pointer-events-none rounded-xl ring-4 ring-cyan-400 ring-offset-2 animate-pulse transition-[top,left,width,height] duration-200"
          style={{ top: rect.top - 4, left: rect.left - 4, width: rect.width + 8, height: rect.height + 8 }}
          data-testid="tour-highlight"
        />
      )}
      <div
        className="fixed z-[9999] left-3 right-3 bottom-4 mx-auto max-w-md bg-white rounded-2xl shadow-2xl border border-cyan-100 p-4"
        style={{ paddingBottom: 'calc(1rem + env(safe-area-inset-bottom))' }}
        data-testid="mobile-tour-card"
      >
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 shrink-0 rounded-xl bg-cyan-50 text-cyan-700 flex items-center justify-center">
            <Icon className="w-5 h-5" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-[11px] text-cyan-700 font-medium" data-testid="tour-step-indicator">
              Passo {currentStep + 1} de {steps.length}
            </p>
            <h3 className="font-semibold text-slate-900" data-testid="tour-step-title">{step.title}</h3>
            <p className="text-sm text-slate-600 mt-0.5">{step.description}</p>
          </div>
          <button onClick={onSkip} className="p-1 text-slate-400 hover:text-slate-600" aria-label="Fechar tour" data-testid="tour-close-btn">
            <X className="w-4 h-4" />
          </button>
        </div>
        <div className="flex items-center justify-between mt-3">
          <Button variant="ghost" size="sm" onClick={onPrev} disabled={currentStep === 0} data-testid="tour-prev-btn">
            <ChevronLeft className="w-4 h-4 mr-1" /> Anterior
          </Button>
          <div className="flex gap-2">
            <Button variant="ghost" size="sm" onClick={onSkip} className="text-slate-400" data-testid="tour-skip-btn">Pular</Button>
            <Button size="sm" onClick={onNext} className="bg-cyan-600 hover:bg-cyan-700" data-testid="tour-next-btn">
              {isLast ? 'Concluir' : 'Próximo'}
              {!isLast && <ChevronRight className="w-4 h-4 ml-1" />}
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};
